export default __webpack_public_path__ + "static/media/headerLogo.3635d15d.svg";